export function mapValue<T = any>(obj: Record<string, T>, mapper: (x: T) => T): Record<string, T> {
  if (typeof obj !== 'object') {
    throw Error('type error, `obj` must be a object.');
  }
  return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, mapper(value)]));
}
